import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Utility to transform form annotations to legacy/report annotation format

const colorObjectToString = color => {
  if (!color) return 'undefined undefined undefined undefined';
  const red = color.red,
    green = color.green,
    blue = color.blue,
    _color$alpha = color.alpha,
    alpha = _color$alpha === void 0 ? 1 : _color$alpha;
  return [red, green, blue, alpha].join(' ');
};
const rectObjectToString = rect => {
  if (!rect || !rect.origin || !rect.size) return null;
  const _rect$origin = rect.origin,
    x = _rect$origin.x,
    y = _rect$origin.y,
    _rect$size = rect.size,
    width = _rect$size.width,
    height = _rect$size.height;
  return "{{".concat(x, ", ").concat(y, "}, {").concat(width, ", ").concat(height, "}}");
};
const translate = {
  FreeText: _ref => {
    let _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Text' : _ref$text,
      _ref$fontName = _ref.fontName,
      fontName = _ref$fontName === void 0 ? 'Helvetica' : _ref$fontName,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize;
    return {
      text,
      fontName,
      fontSize
    };
  },
  Highlight: _ref2 => {
    let _ref2$rectArray = _ref2.rectArray,
      rectArray = _ref2$rectArray === void 0 ? [] : _ref2$rectArray;
    return {
      rectsString: rectArray.map(rect => rectObjectToString(rect)).join('/')
    };
  },
  Ink: _ref3 => {
    let strokeWidth = _ref3.strokeWidth,
      width = _ref3.width,
      _ref3$pointArray = _ref3.pointArray,
      pointArray = _ref3$pointArray === void 0 ? [] : _ref3$pointArray,
      _ref3$unsmoothed = _ref3.unsmoothed,
      unsmoothed = _ref3$unsmoothed === void 0 ? 0 : _ref3$unsmoothed;
    return {
      pathString: pointArray.map(_ref4 => {
        let x = _ref4.x,
          y = _ref4.y;
        return "{".concat(x, ", ").concat(y, "}");
      }).join('/') || '',
      width: width || strokeWidth || 0,
      unsmoothed
    };
  },
  Line: params => translate.Ink(_objectSpread(_objectSpread({}, params), {}, {
    unsmoothed: 1
  })),
  Note: _ref5 => {
    let label = _ref5.text,
      color = _ref5.color;
    return {
      content: JSON.stringify({
        label,
        color: colorObjectToString(color)
      })
    };
  },
  Info: () => ({})
};
const renderTypeMapping = {
  FreeText: 'freeTextAnnotation',
  Highlight: 'highlightAnnotation',
  Ink: 'inkAnnotation',
  Line: 'inkAnnotation',
  Note: 'noteAnnotation',
  Info: 'infoAnnotation'
};
function convertFormAnnotationToLegacyAnnotation(formAnn) {
  const _ref6 = formAnn.content || formAnn,
    render = _ref6.render,
    formType = _ref6.formType;
  if (!render) return null;
  const renderType = render.renderType,
    color = render.color,
    textColor = render.textColor,
    rect = render.rect,
    rotation = render.rotation,
    page = render.page,
    alpha = render.alpha;

  // Guard: return null if renderType is not recognized
  if (!renderType || !renderTypeMapping[renderType] || !translate[renderType]) return null;

  // For FreeText, use color for background and textColor for text
  let colorString;
  if (renderType === 'FreeText') {
    colorString = colorObjectToString(color);
  } else if (renderType === 'Note') {
    colorString = colorObjectToString(color);
  } else if (renderType === 'Line' || renderType === 'Ink') {
    // For line and ink annotations, incorporate alpha value into the color
    // The alpha can come from either the separate alpha property or the color object itself
    let effectiveAlpha = 0.5; // default fallback
    if (alpha !== undefined) {
      effectiveAlpha = alpha;
    } else if (color && color.alpha !== undefined) {
      effectiveAlpha = color.alpha;
    }
    const colorWithAlpha = color ? _objectSpread(_objectSpread({}, color), {}, {
      alpha: effectiveAlpha
    }) : {
      red: 0,
      green: 0,
      blue: 0,
      alpha: effectiveAlpha
    };
    colorString = colorObjectToString(colorWithAlpha);
  } else {
    colorString = colorObjectToString(color || textColor);
  }
  let textColorString;
  if (renderType === 'Note') {
    textColorString = textColor ? colorObjectToString(textColor) : undefined;
  } else {
    textColorString = textColor ? colorObjectToString(textColor) : undefined;
  }
  const translated = _objectSpread({
    id: formAnn.id
  }, translate[renderType](render));
  const rectString = rectObjectToString(rect);
  if (!rectString) return null; // Return null if we can't create a valid rectString

  const annotation = {
    id: formAnn.id,
    formType,
    rotation,
    pageNumber: page,
    rectString,
    colorString,
    color: color ? colorObjectToString(color) : undefined,
    textColor: textColorString,
    [renderTypeMapping[renderType]]: translated
  };
  return annotation;
}

// Converts a legacy rectString (e.g., '{{x, y}, {width, height}}') to a form rect object
const legacyRectStringToFormRect = rectString => {
  if (!rectString) return null;
  const match = rectString.match(/\{\{([\d.-]+), ([\d.-]+)\}, \{([\d.-]+), ([\d.-]+)\}\}/);
  if (!match) return null;
  return {
    origin: {
      x: parseFloat(match[1]),
      y: parseFloat(match[2])
    },
    size: {
      width: parseFloat(match[3]),
      height: parseFloat(match[4])
    }
  };
};

// Converts a legacy pathString (e.g., '{x1, y1}/{x2, y2}/...') to a form pointArray
const pathStringToPointArray = pathString => {
  if (!pathString) return [];
  return pathString.split('/').map(segment => {
    const match = segment.match(/\{([\d.-]+), ([\d.-]+)\}/);
    if (!match) return null;
    return {
      x: parseFloat(match[1]),
      y: parseFloat(match[2])
    };
  }).filter(Boolean);
};
export { convertFormAnnotationToLegacyAnnotation, legacyRectStringToFormRect, pathStringToPointArray };